export const locale = {
    lang: 'ru',
    data: {
        'TOOLBAR': {
            'TOOLTIP_ADD': 'Нажмите, чтобы добавить/удалить ярлык',
            'SEARCH_PLACEHOLDER': 'Поиск страниц'
        }
    }
};



// WEBPACK FOOTER //
// ./src/@fuse/components/shortcuts/i18n/ru.ts